<template>
  <div class="onboard-arrow" v-show="show" :style="[{right: right + 'px'}, {bottom: bottom + 'px'}]">
    <div class="arrow_box no-print animated infinite onboarding_animate"></div>
  </div>
</template>

<script>
  export default {
    props: {
      bottom: {
        default: -4
      },
      right: {
        default: 0
      }
    },
    computed: {
      activeOnboardingStep () {
        return this.$store.state.onboardingStep
      },
      show () {
        return this.activeOnboardingStep * 1 === 5
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .onboard-arrow {
    position: absolute;
    right: 0;
    bottom: -2px;
  }

  .arrow_box {
    display: inline-block;
    height: 40px;
    width: 40px;
    position: relative;
    background: var(--green);
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  }

  .arrow_box:after, .arrow_box:before {
    left: -40px;
    top: 5px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:before {
    border-right-color: var(--green);
    border-width: 15px 25px 15px;
    border-radius: 4px 4px 0 0;
  }

  @keyframes pulseLeft {
    0% {
      transform: translate3d(50%, 0, 0);
    }
    50% {
      transform: translate3d(00%, 0, 0);
    }
    100% {
      transform: translate3d(50%, 0, 0);
    }
  }

  .onboarding_animate {
    animation-name: pulseLeft;
  }

</style>



// WEBPACK FOOTER //
// OnboardArrowVacationDaySelector.vue?0b4fede7